module.exports = __webpack_public_path__ + "img/equipo_16-9_1440.46dc4af4.jpg";